import __request__ from "routing/request";
export function listBundles(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.illuminate/bundles/hub", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function retrieveLatest(requestOptions) {
  return __request__("PUT", "/plugins/org.graylog.plugins.illuminate/bundles/hub/fetch_latest", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getLatestVersion(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.illuminate/bundles/hub/latest", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getReleaseNotes(version, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.illuminate/bundles/hub/release_notes/${version}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function download(version, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.illuminate/bundles/hub/${version}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
